export var TITLE = 'Cohere';
export var TEXT_MULTIPLE = 1;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#39594D';